<template>
    <div>
        <div class="vx-row mb-2 mt-2" style="width:70%">
            <div class="vx-col sm:w-1/4 w-full">
                <vs-button color="primary" @click="handleExport()">Export</vs-button>
            </div>
        </div>
        <vs-table search stripe border description :sst="true" :data="table.data" :max-items="table.length"
            :total="table.total" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort">
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
                            {{ this.table.total }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                            <span>{{ item }}</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </template>
            <template slot="thead">
                <vs-th sort-key="">GR Number</vs-th>
                <vs-th sort-key="">Transaction Type</vs-th>
                <vs-th sort-key="">GR Date</vs-th>
                <vs-th sort-key="">Supplier Code</vs-th>
                <vs-th sort-key="">Supplier Description</vs-th>
                <vs-th sort-key="">SKU Code</vs-th>
                <vs-th sort-key="">SKU Description</vs-th>
                <vs-th sort-key="">Qty</vs-th>
                <vs-th sort-key="">Unit</vs-th>
                <vs-th sort-key="">Batch Number</vs-th>
                <vs-th sort-key="">Expiry Date</vs-th>
                <vs-th sort-key="">Shelf Life Supplier SKU</vs-th>
                <vs-th sort-key="">Shelf Life Aging</vs-th>
                <vs-th sort-key="">Shelf Life Status</vs-th>
                <vs-th sort-key="">GR Status</vs-th>
                <vs-th sort-key="">Approver</vs-th>
                <vs-th sort-key="">Notes Approval</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.gr_number }}</vs-td>
                    <vs-td>{{ tr.trx_type }}</vs-td>
                    <vs-td>{{ formatDateZ(tr.gr_date) }}</vs-td>
                    <vs-td>{{ tr.supplier_code }}</vs-td>
                    <vs-td>{{ tr.supplier_description }}</vs-td>
                    <vs-td>{{ tr.sku_code }}</vs-td>
                    <vs-td>{{ tr.sku_description }}</vs-td>
                    <vs-td>{{ tr.qty }}</vs-td>
                    <vs-td>{{ tr.unit }}</vs-td>
                    <vs-td>{{ tr.batch_number }}</vs-td>
                    <vs-td>{{ tr.expiry_date }}</vs-td>
                    <vs-td>{{ tr.shelf_life_supplier_sku }}</vs-td>
                    <vs-td>{{ tr.shelf_life_aging }}</vs-td>
                    <vs-td>{{ tr.shelf_life_status }}</vs-td>
                    <vs-td>{{ tr.gr_status }}</vs-td>
                    <vs-td>{{ tr.approver }}</vs-td>
                    <vs-td>{{ tr.notes_approval }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
    </div>
</template>
<script>
import moment from "moment";
export default {
    components: {},
    props: {
        draw: {
            type: Number,
        },
        whIDs: {
            type: String,
        },
        trxType: {
            type: String,
        },
        grStatus: {
            type: String,
        },
        grDateRange: {
            type: Object,
        },
    },
    data() {
        return {
            confirmId: null,
            table: this.tableDefaultState(),
        };
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
                length: 10,
                page: 1,
                search: "",
                order: "gr_number",
                sort: "desc",
                total: 0,
                totalPage: 1,
                totalSearch: 0,
                limits: [10, 25, 50, 100, "All"],
                start: 1,
                end: 0,
            };
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            this.getData();
        },
        handleChangePage(page) {
            this.table.page = page;
            if (this.draw > 0) {
                this.getData();
            }
        },
        handleSort(key, active) {
            this.table.order = key;
            this.table.sort = active;
            this.getData();
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData();
        },
        handleClose() {
            this.getData();
            this.$emit("close");
        },
        getData() {
            this.$vs.loading();
            const params = {
                length: this.table.length,
                page: this.table.page,
                search: this.table.search,
                order: this.table.order,
                sort: this.table.sort,
                wh_ids: this.whIDs,
                trx_type: this.trxType,
                gr_status: this.grStatus,
                start_date: moment(this.grDateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.grDateRange.endDate).format("YYYY-MM-DD"),
            };

            this.$http
                .get(this.$store.state.report.grShelfLifeReport.baseUrlPath, { params })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.table.total = resp.data.total_record;
                        this.table.totalPage = resp.data.total_page;
                        this.table.totalSearch = resp.data.total_record_search;
                        this.table.length = resp.data.total_record_per_page;
                        this.table.data = resp.data.records;
                        this.setStartEnd();
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                    }
                });
        },
        setStartEnd() {
            let valStart =
                this.table.length * this.table.page - this.table.length + 1;

            if (valStart > this.table.total) {
                valStart = 1;
            }
            if (this.table.total == 0) {
                valStart = 0;
            }
            let valEnd = this.table.length * this.table.page;

            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }

            if (
                this.table.totalSearch < this.table.total &&
                this.table.search != ""
            ) {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        utcToLocal(val) {
            if (val) {
                return moment(val)
                    .add(-7, "h")
                    .utc()
                    .local()
                    .format("DD MMM YYYY HH:mm:ss");
            }
        },
        formatDateZ(date) {
            return date ? moment(date).format('YYYY-MM-DD') : '-'
        },
        formatDate(dateString) {
            // Ubah string tanggal menjadi objek Date
            let date = new Date(dateString);
            // Format tanggal sesuai kebutuhan ("YYYY-MM-DD")
            let formattedDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
            return formattedDate;
        },
        getCurrentDate() {
            let today = new Date();
            let formattedDate = today.getFullYear() + '-' + (today.getMonth() + 1).toString().padStart(2, '0') + '-' + today.getDate().toString().padStart(2, '0');
            return formattedDate;
        },
        handleExport() {
            this.$vs.loading();
            this.$http
            .post(this.$store.state.log.logExport.baseUrlPath, {
                file_name: "GR-Shelf-Life-" + moment().format('YYYY-MM-DD'),
                warehouse_ids: this.whIDs,
                trx_type: this.trxType,
                gr_status: this.grStatus,
                start_date: moment(this.grDateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.grDateRange.endDate).format("YYYY-MM-DD"),
                type: "gr-shelf-life"
            })
            .then((resp) => {
                if (resp.code == 200) {
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    text: resp.message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                });
                this.$vs.loading.close();
                } else {
                this.$vs.notify({
                    color: "danger",
                    title: "Form Validation",
                    text: resp.message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                });
                this.$vs.loading.close();
                }
            });
        },
    },
    mounted() { },
    watch: {
        draw() {
            if (this.draw > 0) {
                this.getData();
            }
        },
    },
    computed: {
        setPage: {
            get() {
                return this.table.page;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
    },
};
</script>
